jQuery(document).ready(function ($) {
  if (Shopify.locale == "fr") {
    var mylist = $("#HeaderMenu-SubMenuList-2");
    var listitems = mylist.children("li").get();
    listitems.sort(function (a, b) {
      return $(a).text().toUpperCase().localeCompare($(b).text().toUpperCase());
    });
    $.each(listitems, function (idx, itm) {
      mylist.append(itm);
    });

    /* Northern Seeds (Nov 2026): sort the dropdown menus alphabetically in French,
       keeping the first "All ..." link on top */
    $(".mega-menu__list").each(function () {
      var list = $(this);
      var items = list.children("li").get();
      if (items.length < 4) return;
      var first = items.shift();
      items.sort(function (a, b) {
        return $(a).text().trim().localeCompare($(b).text().trim(), "fr", { sensitivity: "base" });
      });
      list.append(first);
      $.each(items, function (i, itm) { list.append(itm); });
    });
  }
});

/* Northern Seeds (Nov 2026): free lettermail shipping progress in the side cart */
(function () {
  var THRESHOLD = 3500; /* cents; matches the free shipping threshold */
  var fr = (window.Shopify && Shopify.locale === "fr");

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return fr ? v.replace(".", ",") + " $" : "$" + v;
  }

  function render(cart) {
    var inner = document.querySelector("cart-drawer .drawer__inner");
    if (!inner) return;
    var bar = inner.querySelector(".ns-ship");
    if (!cart || cart.item_count === 0) { if (bar) bar.remove(); return; }
    var remaining = THRESHOLD - cart.total_price;
    var pct = Math.max(0, Math.min(100, Math.round((cart.total_price / THRESHOLD) * 100)));
    var text = remaining > 0
      ? (fr ? "Plus que " + money(remaining) + " pour la livraison gratuite par poste-lettre."
            : "You're " + money(remaining) + " away from free lettermail shipping.")
      : (fr ? "Votre commande est admissible à la livraison gratuite par poste-lettre."
            : "Your order qualifies for free lettermail shipping.");
    if (!bar) {
      bar = document.createElement("div");
      bar.className = "ns-ship";
      bar.setAttribute("role", "status");
      bar.innerHTML = '<p class="ns-ship__text"></p><div class="ns-ship__track"><div class="ns-ship__fill"></div></div>';
      var header = inner.querySelector(".drawer__header");
      if (header && header.nextSibling) inner.insertBefore(bar, header.nextSibling); else inner.prepend(bar);
    }
    bar.querySelector(".ns-ship__text").textContent = text;
    bar.querySelector(".ns-ship__fill").style.width = pct + "%";
    bar.classList.toggle("ns-ship--done", remaining <= 0);
  }

  var pending = null;
  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart.js", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }, 150);
  }

  function watch() {
    var drawer = document.querySelector("cart-drawer");
    if (!drawer) return;
    refresh();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.closest && t.closest(".ns-ship")) continue;
        refresh();
        return;
      }
    }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watch); else watch();
})();

/* Northern Seeds (Oct 2026): tag newsletter sign-ups by site language (lang-en / lang-fr)
   and offer a link to sign up in the other language */
(function () {
  function run() {
    var fr = (window.Shopify && Shopify.locale === "fr");
    var lang = fr ? "fr" : "en";
    var inputs = document.querySelectorAll('form input[name="contact[tags]"]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (!/newsletter/.test(input.value) || /lang-/.test(input.value)) continue;
      input.value = input.value + ",lang-" + lang;
      var form = input.form;
      if (!form) continue;
      if (!form.id) form.id = "ns-signup-" + i;
      if (form.parentNode.querySelector(".ns-lang-switch")) continue;
      var p = document.createElement("p");
      p.className = "ns-lang-switch";
      var a = document.createElement("a");
      a.href = (fr ? "/" : "/fr") + "#" + form.id;
      a.lang = fr ? "en" : "fr";
      a.hreflang = a.lang;
      a.textContent = fr ? "Subscribe in English →" : "S’abonner en français →";
      p.appendChild(a);
      form.insertAdjacentElement("afterend", p);
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run); else run();
})();
